import styled, { css } from 'styled-components';
import LinkOutStroke from '@ad-scripts/presentation/components/common/icons/stroke/link-out-stroke';

export const StyledLink = styled.a`
  margin-top: 20px;
  display: flex;
  align-items: center;

  svg {
    width: 16px;
    margin-left: 4px;
    fill: ${p => p.theme.colors.green400};
  }
`;

export const StyledCardIcon = styled.div`
  position: absolute;
  left: 24px;
  width: 48px;
  height: 48px;
  background-color: ${p => p.theme.colors.green100};
  border-radius: 4px;
  display: flex;
  justify-content: center;

  svg {
    width: 30px;
    fill: ${p => p.theme.colors.green400};
  }
`;

export const StyledColumnSecondary = css`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-right: 15px;
  color: inherit;

  ${StyledCardIcon} {
    display: none;
  }
`;

export const ExternalLink = styled(LinkOutStroke)`
  display: none;
  position: absolute;
  width: 24px;
  height: 24px;
  top: 0;
  bottom: 0;
  right: 24px;
  margin: auto;
  fill: ${p => p.theme.colors.gray600};
`;

export const StyledColumnDescription = styled.div`
  line-height: 21px;
  margin-top: 8px;
`;
